import { memo, useState } from "react";
import MenuTab from "../MenuTab";
import Branch from "./Branch";
import Course from "./Course";
import Subject from "./Subject";

function InformationCenter() {
    const [currentValue, setCurrentValue] = useState<number>(1);
    const handleGetValue = (value: number) => {
        setCurrentValue(value);
    }

    return (<div className="text-white p-[20px] pt-[10px] w-full h-full">
        <h1 className="font-bold text-[30px] text-center">THÔNG TIN TRUNG TÂM</h1>
        <div className="mt-[20px]">
            <MenuTab currentValue={handleGetValue} />
            {currentValue === 1 && <Branch />}
            {currentValue === 2 && <Course />}
            {currentValue === 3 && <Subject />}
        </div>
    </div>);
}

export default memo(InformationCenter);